import { render } from "./LogoSVG.vue?vue&type=template&id=38ac6d0f"
import script from "./LogoSVG.vue?vue&type=script&lang=js"
export * from "./LogoSVG.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__